import { MenuItem, Pagination } from "@mui/material";
import React, { useState, useEffect } from "react";
import TextInput from "../form/TextInput";

function OrderPaginationClone({
  totalCount = 0,
  callback,
  perPage: defaultPerPage = 10,
  page: defaultPage = 1,
}) {
  const [page, setPage] = useState(defaultPage);
  const [perPage, setPerPage] = useState(defaultPerPage);

  const pageCount = Math.ceil(Math.max(totalCount, perPage) / perPage);

  useEffect(() => {
    callback?.({ page, perPage });
  }, [page, perPage]);

  useEffect(() => {
    setPage(defaultPage);
  }, [defaultPage]);

  useEffect(() => {
    setPerPage(defaultPerPage);
  }, [defaultPerPage]);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handlePerPageChange = (ev) => {
    const newPerPage = Number(ev.target.value || 10);
    setPerPage(newPerPage);
    setPage(1);
  };

  const pageOptions = [10, 20, 30, 40];

  return (
    <div className="flex flex-wrap justify-end mt-10 gap-4">
      <Pagination
        count={pageCount}
        page={page}
        onChange={handlePageChange}
        variant="outlined"
        shape="rounded"
      />
      <div className="inline-block">
        <TextInput
          select
          label=""
          className="!h-6 !text-xs"
          value={perPage}
          onChange={handlePerPageChange}
          sx={{
            "& .MuiInputBase-root": { height: "32px" },
            "& .MuiOutlinedInput-notchedOutline": { borderRadius: "4px" },
            "& .MuiInputLabel-root": { lineHeight: "32px" },
          }}
        >
          {pageOptions.map((val) => (
            <MenuItem key={val} value={val}>
              {val} / page
            </MenuItem>
          ))}
        </TextInput>
      </div>
    </div>
  );
}

export default OrderPaginationClone;
